export default "__VITE_ASSET__DxK_$Lsk__"